import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const fetchEasyPayBanks = async () => {
  const response = await getData(
    ajaxEndpoints.FETCH_EASY_PAY_FINANCIAL_INSTITUTIONS,
  );
  return response?.data;
};

export const useFetchEasyPayBanks = () => {
  return useQuery("fetchEasyPayBanks", () => fetchEasyPayBanks());
};
